import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  GET_COMMUNICATION_CONTACTS,
  ADD_COMMUNICATION_CONTACTS,
  EDIT_COMMUNICATION_CONTACTS,
  GET_COMMUNICATION_PREFERENCES,
  UPDATE_COMMUNICATION_PREFERENCES,
  GET_COMMUNICATION_ADDRESS,
  UPDATE_COMMUNICATION_ADDRESS,
  EMAIL_TO_CUSTOMER,
} from "../../../../Urls.js";

const initialState = {
  contactsList: { data: [], loader: false },
  createContactsData: { data: {}, loader: false, successMessage: "" },
  editContactsData: { data: {}, loader: false, successMessage: "" },
  selectedContactData: { data: {} },
  selectedMesage: {},
  communicationList: { data: [], loader: false },
  updateCommunicationData: { data: {}, loader: false, successMessage: "" },
  getAddressData: { data: {}, loader: false, successMessage: "" },
  updateAddressData: { data: {}, loader: false, successMessage: "" },
  emsilToCustomer: { data: {}, loader: false }
};

export const getCommunicationContacts = createAsyncThunk(
  "app/get/getCommunicationContacts",
  async (billing_group_id) => {
    const resMessageList = await axios.get(
      GET_COMMUNICATION_CONTACTS + billing_group_id
    );
    return resMessageList;
  }
);

export const addCommunicationContacts = createAsyncThunk(
  "app/get/addCommunicationContacts",
  async (data) => {
    const response = await axios.post(ADD_COMMUNICATION_CONTACTS, { ...data });
    return response;
  }
);
export const editCommunicationContacts = createAsyncThunk(
  "app/get/editCommunicationContacts",
  async (data) => {
    const response = await axios.post(
      EDIT_COMMUNICATION_CONTACTS + data?.contact_id,
      { ...data }
    );
    return response;
  }
);

export const getCommunicationPreferences = createAsyncThunk(
  "app/get/getCommunicationPreferences",
  async (crm_service_account_id) => {
    const resMessageList = await axios.get(
      GET_COMMUNICATION_PREFERENCES + crm_service_account_id
    );
    return resMessageList;
  }
);
export const getCommunicationAddress = createAsyncThunk(
  "app/get/getCommunicationAddress",
  async (crm_service_account_id) => {
    const resMessageList = await axios.get(
      GET_COMMUNICATION_ADDRESS + crm_service_account_id
    );
    return resMessageList;
  }
);

export const updateCommunicationPreferences = createAsyncThunk(
  "app/get/updateCommunicationPreferences",
  async (data) => {
    const response = await axios.post(UPDATE_COMMUNICATION_PREFERENCES, data);
    return response;
  }
);
export const updateUserDetails = createAsyncThunk(
  "app/patch/updateuserDetails",
  async (data) => {
    const { userId, ...payload } = data;
    
    const response = await axios.patch(`/api/v1/customer/${userId}`, payload );
    return response;
  }
);
export const updateCommunicationAddress = createAsyncThunk(
  "app/get/updateCommunicationAddress",
  async (data) => {
    const response = await axios.post(UPDATE_COMMUNICATION_ADDRESS + data.billing_group_id, data);
    return response;
  }
);

export const sentMailtoCustomer = createAsyncThunk(
  "app/post/sendMailToCustomer",
  async (data) => {
    const response = await axios.post(EMAIL_TO_CUSTOMER, { ...data });
    return response;
  }
)

export const communicationSlice = createSlice({
  name: "app/communicationSlice",
  initialState,
  reducers: {
    selectedMesage: (state, action) => {
      state.selectedMesage = action?.payload;
    },
    clearSuccessMessage: (state) => {
      state.createContactsData.successMessage = "";
      state.editContactsData.successMessage = "";
    },
    clearSuccessMessageCommunication: (state) => {
      state.updateCommunicationData.successMessage = "";
    },
    clearAddressDatamessage: (state) => {
      state.updateAddressData.successMessage = "";
    },
    setSelectedContact: (state, action) => {
      state.selectedContactData = action?.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCommunicationContacts.pending, (state) => {
        state.contactsList.loader = true;
      })
      .addCase(getCommunicationContacts.fulfilled, (state, action) => {
        state.contactsList.loader = false;
        state.contactsList.data = action?.payload?.data?.data;
      })
      .addCase(getCommunicationContacts.rejected, (state) => {
        state.contactsList.loader = false;
      })
      .addCase(addCommunicationContacts.pending, (state) => {
        state.createContactsData.loader = true;
      })
      .addCase(addCommunicationContacts.fulfilled, (state, action) => {
        state.createContactsData.loader = false;
        state.createContactsData.data = action?.payload?.data?.data;
        state.createContactsData.successMessage =
          "Contact details added successfully!";
      })
      .addCase(addCommunicationContacts.rejected, (state) => {
        state.createContactsData.loader = false;
        state.createContactsData.data = {};
        state.createContactsData.successMessage =
          "Failed to add Contact details!";
      })
      .addCase(editCommunicationContacts.pending, (state) => {
        state.editContactsData.loader = true;
      })
      .addCase(editCommunicationContacts.fulfilled, (state, action) => {
        state.editContactsData.loader = false;
        state.editContactsData.data = action?.payload?.data?.data;
        state.editContactsData.successMessage =
          "Contact details updated successfully!";
      })
      .addCase(editCommunicationContacts.rejected, (state) => {
        state.editContactsData.loader = false;
        state.editContactsData.data = {};
        state.editContactsData.successMessage =
          "Failed to update Contact details!";
      })

      .addCase(getCommunicationPreferences.pending, (state) => {
        state.communicationList.loader = true;
      })
      .addCase(getCommunicationPreferences.fulfilled, (state, action) => {
        state.communicationList.loader = false;
        state.communicationList.data = action?.payload?.data?.data;
      })
      .addCase(getCommunicationPreferences.rejected, (state) => {
        state.communicationList.loader = false;
      })
      .addCase(updateCommunicationPreferences.pending, (state) => {
        state.updateCommunicationData.loader = true;
      })
      .addCase(updateCommunicationPreferences.fulfilled, (state, action) => {
        state.updateCommunicationData.loader = false;
        state.updateCommunicationData.data = action?.payload?.data?.data;
        state.updateCommunicationData.successMessage =
          "Communication preferences updated successfully!";
      })
      .addCase(updateCommunicationPreferences.rejected, (state) => {
        state.updateCommunicationData.loader = false;
        state.updateCommunicationData.data = {};
        state.updateCommunicationData.successMessage =
          "Failed to update Communication preferences!";
      })
      .addCase(updateCommunicationAddress.pending, (state) => {
        state.updateAddressData.loader = true;
      })
      .addCase(updateCommunicationAddress.fulfilled, (state, action) => {
        state.updateAddressData.loader = false;
        state.updateAddressData.data = action?.payload?.data;
        state.updateAddressData.successMessage =
          "Communication Address updated successfully!";
      })
      .addCase(updateCommunicationAddress.rejected, (state) => {
        state.updateAddressData.loader = false;
        state.updateAddressData.data = {};
        state.updateAddressData.successMessage =
          "Failed to update Communication Address!";
      })

      //email to customer      
      .addCase(sentMailtoCustomer.pending, (state) => {
        state.emsilToCustomer.loader = true;
      })
      .addCase(sentMailtoCustomer.fulfilled, (state, action) => {
        state.emsilToCustomer.loader = false;
        state.emsilToCustomer.data = action?.payload?.data?.data;
      })
      .addCase(sentMailtoCustomer.rejected, (state) => {
        state.emsilToCustomer.loader = false;
      })

      .addCase(getCommunicationAddress.pending, (state) => {
        state.getAddressData.loader = true;
      })
      .addCase(getCommunicationAddress.fulfilled, (state, action) => {
        state.getAddressData.loader = false;
        state.getAddressData.data = action?.payload?.data?.data;
      })
      .addCase(getCommunicationAddress.rejected, (state) => {
        state.getAddressData.loader = false;
      });
  },
});

export const {
  selectedMesage,
  clearSuccessMessage,
  clearSuccessMessageCommunication,
  setSelectedContact,
  clearAddressDatamessage,
} = communicationSlice.actions;

export default communicationSlice.reducer;
